import React, { useState } from "react";
import {
  Avatar,
  CssBaseline,
  TextField,
  Paper,
  Box,
  Grid,
  Typography,
} from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { loginUser } from "../../redux/actions/auth.jsx";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import login from "../../api/auth.jsx";
import BackgoundIcon from "../../assets/images/bg-night.jpeg";
import Copyright from "../Container/Copyright.jsx";
import { useForm } from "react-hook-form";

const theme = createTheme();

const listInput = [
  {
    type: "text",
    label: "Username",
    name: "username",
  },
  {
    type: "password",
    label: "Password",
    name: "password",
  },
];

export default function SignInSide() {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [loading, setLoading] = useState(false);

  const onHandleSubmit = async (formData) => {
    setLoading(true);
    const result = await login({ formData });
    if (result === "Network Error") {
      setLoading(false);
      return enqueueSnackbar(result, { variant: "error" });
    }
    if (result.status === "success") {
      setLoading(false);
      dispatch(loginUser(result.data.token));
      window.location.replace("/");
    } else {
      setLoading(false);
      enqueueSnackbar(result.message, { variant: result.status });
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            background: `url(${BackgoundIcon})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
              <LockOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
              Sign in
            </Typography>
            <Box
              component="form"
              onSubmit={handleSubmit(onHandleSubmit)}
              sx={{ mt: 1 }}
            >
              {listInput.map((el, index) => (
                <TextField
                  key={el.name + "-" + index}
                  error={errors[el.name] !== undefined}
                  {...register(el.name, {
                    required: {
                      value: true,
                      message: "Field Tidak Boleh Kosong",
                    },
                    maxLength: {
                      value: 30,
                      message: "30 length",
                      name: el.name,
                    },
                    minLength: {
                      value: 3,
                      message: "min 3 length",
                      name: el.name,
                    },
                  })}
                  margin="normal"
                  fullWidth
                  type={el.type}
                  label={el.label}
                  autoFocus={el.name === "username"}
                  helperText={errors[el.name] && errors[el.name].message}
                />
              ))}
              <LoadingButton
                type="submit"
                fullWidth
                loading={loading}
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                Login
              </LoadingButton>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}
